import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading04, typeBody02, typeLabel01 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, gutter, SIZE, mediaQuery } from '../../theme/metrics'
import { WHITE_01, GREY_01 } from '../../theme/colors'

export const Inner = styled.div`
	${props => row({medium:true})}

	${mediaQuery[SIZE.medium]}{
		padding-top: ${spacer(2)};
	}
`

export const ContentContainer = styled.div`
	${props => column({medium:{span:5,before:1}},{direction:props.theme.direction})}
	padding-top: ${spacer(1)};

	${mediaQuery[SIZE.medium]}{
		padding-top: 0;
	}
`

export const TextContent = styled.div`

`

export const Heading = styled.div`
	${typeHeading02}
	color: ${props => props.theme.foreground};
	margin-bottom: ${unit(3)};
`

export const ImageContainer = styled.div`
	${props => column({medium:{span:6}},{direction:props.theme.direction})}
	padding-top: ${margin(SIZE.small)};

	${mediaQuery[SIZE.medium]}{
		padding-top: 0;
	}
`

export const ImageInner = styled.div`
	
	flex: 1;
	position: relative;

	&:before{
		content: "";
		width: 100%;
		height: 100%;
		position: absolute;
		top: ${margin(SIZE.small,{multiplier:-1})};
		left: ${margin(SIZE.small,{multiplier:-1})};
		background-color: ${props => props.theme.shadow};

		${mediaQuery[SIZE.medium]}{
			top: ${spacer(-2)};
			left: ${margin(SIZE.medium,{multiplier:-1})};
		}

		${mediaQuery[SIZE.large]}{
			left: ${margin(SIZE.large,{multiplier:-1})};
		}

		${mediaQuery[SIZE.max]}{
			left: ${margin(SIZE.large,{multiplier:-1})};
		}

	}
`

export const StepList = styled.ol`
	counter-reset: count;
`

export const StepItem = styled.li`
	margin-bottom: ${spacer(1)};
	counter-increment: count;
	position: relative;
	padding-left: ${unit(4)};

	${mediaQuery[SIZE.medium]}{
		padding-left: 0;
	}

	&:before{
		content: counter(count);
		width: ${unit(3)};
		height: ${unit(3)};
		border-radius: 50%;
		background-color: ${props => props.theme.foreground};
		color: ${props => props.theme.background};
		display: flex;
		font-family: 'BwGradual-Regular';
		font-size: 15px;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 8px;
		left: 0;
		transform: translateX(-50%);

		${mediaQuery[SIZE.medium]}{
			width: ${spacer(1)};
			height: ${spacer(1)};
			font-size: 18px;
			top: 0;
			left: ${gutter(SIZE.medium,{multiplier:-1})};
			transform: translateX(-100%);
		}

		${mediaQuery[SIZE.large]}{
			left: ${gutter(SIZE.large,{multiplier:-1})};
			top: 14px;
		}

		${mediaQuery[SIZE.max]}{
			left: ${gutter(SIZE.large,{multiplier:-1})};
		}
	}

	&:last-child{
		margin-bottom: 0;
	}
`

export const Subheading = styled.div`
	${typeHeading02}
	color: ${props => props.theme.foreground};
	margin-bottom: ${unit(2)};
`

export const Text = styled.div`
	${typeBody02}
	color: ${props => props.theme.foreground};
	
`

